import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";

import FilterSlider from "../FilterSlider";
import FilterListItem from "../FilterListItem";

export interface SliderFilterProps {
  title: string;
  name?: string;
  tooltip?: string;
  value: number[];
  min: number;
  max: number;
  step?: number;
  marks?: { value: number; label: string }[];
  note?: string;
  disabled?: boolean;
  loading?: boolean;
  open?: boolean;
  icon?: React.ReactNode;
  setOpen: (value: boolean) => void;
  onChange: (value: number[]) => void;
}

const SliderFilter: React.FC<SliderFilterProps> = ({
  title,
  value,
  tooltip,
  disabled,
  loading,
  open,
  icon,
  min,
  max,
  step = 1,
  marks = [],
  note = "",
  onChange,
  setOpen,
}) => {
  const [valueCurrent, setValue] = useState<number[]>(value);

  useEffect(() => {
    setValue(value);
  }, [value]);

  return (
    <FilterListItem 
      title={title} 
      tooltip={tooltip} 
      icon={icon} 
      selected={valueCurrent[0] !== min || valueCurrent[1] !== max ? `${valueCurrent[0]}-${valueCurrent[1]}` : 0} 
      open={open} 
      setOpen={setOpen}
    >
      <FilterSlider
        value={valueCurrent}
        min={min}
        max={max}
        step={step}
        marks={marks}
        note={note}
        disabled={disabled || loading}
        onChange={(value: number | number[]) => {
          if (Array.isArray(value)) {
            setValue(value);
          }
        }}
        onBlur={() => {
          onChange(valueCurrent);
        }}
      />
      <Box padding={4}>
        <Button
          variant="outlined"
          size="small"
          disabled={loading || disabled}
          onClick={() => {
            setValue([min, max]);
            onChange([min, max]);
          }}
        >
          Reset
        </Button>
      </Box>
    </FilterListItem>
  );
};

export default SliderFilter; 